import { Year } from './../services/year.service';
import { Test_Taker } from './test_taker.model';
import { Component, Injectable, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { AuthenticationService, TestData, TokenPayload } from '../services/authentication.service';
import { Router } from '@angular/router';
import {MediaMatcher} from '@angular/cdk/layout';
import {ChangeDetectorRef} from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, NgForm } from '@angular/forms';
import { TestTakerService } from '../services/test_taker.service';
import { College_Names, CollegeService, collegedetails } from '../services/College_name.service';
import { YearService } from '../services/year.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {MatSortModule, MatSort} from '@angular/material/sort';
import { MatDialog, MatDialogConfig } from "@angular/material";
import Swal from 'sweetalert2';

@Component({
  templateUrl: './test_taker.component.html',
  styleUrls: ['./test_taker.component.scss']
})
@Injectable()
export class TestTakerComponent implements OnInit {
  displayedColumns: string[] = ['S.No.','First_Name','Roll_Number','Department','UG_CGPA','Tenth_Std_Mark','Twelfth_Std_Mark'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild("content") modalContent: TemplateRef<any>;
  searchKey: string;
  dataSource: MatTableDataSource<any>;
  fieldArray: Array<Test_Taker> = [];
  result: string[];
  userAdmin: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  questionset: boolean;
  display: boolean;
  scheduletest: boolean;
  overall: boolean;
  mobileQuery: MediaQueryList;
  screenWidth: number | undefined;
  screenHeight: number | undefined;
  isCustomStyleApplied: boolean = false;
  evaluate: boolean;
  selectedindex;
  local: collegedetails = { collegeid: '', yearid: '' , setid:''};
  private _mobileQueryListener: () => void;

  links = ['Super Admin', 'Admin', 'Test Scheduler'];
  user;
  fname;
  lname;
  college: any;
  selectedcollegeset: any;
  Year: any;
  myForm: FormGroup;
  newAttribute: { candidatename: string; college_name: string; academic_year: string; questionsetname: string; pattern: string; date: string; time: string; paperlist: string; scheduler: string; };
  selectedyearset: any;
  yearid: any;
  collegeid: any;
  display_cand: boolean;
  dropdownhide: boolean = true;
  searchhide:boolean=false;
  Year_Name: any;
  College_Name1: any;
  userEvaluator: boolean;

  constructor(private fb: FormBuilder,private auth: AuthenticationService, private router: Router,
              private testtakerservice: TestTakerService, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher,  private fs:CollegeService,private ys:YearService) {

    this.getAccess()
    this.simpletest();
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.College_Name();
    this.getTempRowData();
  }
  columns: string[];
  // tslint:disable-next-line: member-ordering

  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };
  college_set: College_Names={
    college_name:''
  }
  year_set: Year={
    academic_year:''
  }

  ngOnInit() {
    this.getScreenSize();
    this.applyStylesBasedOnResolution();
   }

   getScreenSize(): void {
    this.screenWidth = window.innerWidth;
   
    this.screenHeight = window.innerHeight;
    
  }
 
applyStylesBasedOnResolution(): void {
    if (this.screenWidth && this.screenHeight) {
      
      if (this.screenWidth < 1366 && this.screenHeight <  641) {
        this.isCustomStyleApplied = true;
        
      }
    }
  }
  
   onSearchClear() {
    this.searchKey = "";
    this.applyFilter();
  }

  applyFilter() {
    this.dataSource.filter = this.searchKey.trim().toLowerCase();
  }

  // getAccess(){
  //   this.user = sessionStorage.getItem('user');
  //   this.fname = sessionStorage.getItem('fname');

  //   this.lname = sessionStorage.getItem('lname');


  //   if (this.user === '2') {

  //     this.userAdmin = true;
  //     this.userSuperAdmin = false;
  //     this.userTestScheduler = true;
  //   } else if (this.user === '1') {

  //     this.userAdmin = true;
  //     this.userSuperAdmin = true;
  //     this.userTestScheduler = true;
  //   } else if (this.user === '3') {
  //     this.userAdmin = false;
  //     this.userSuperAdmin = false;
  //     this.userTestScheduler = true;
  //   }
  // }

  getAccess(){
    this.user = sessionStorage.getItem('user');
    this.fname = sessionStorage.getItem('fname');

    this.lname = sessionStorage.getItem('lname');


    if (this.user === '1') {
      this.userAdmin = true;
      this.userTestScheduler = false;
      this.userEvaluator = false;
    } else if (this.user === '2') {
      this.userEvaluator = true;
      this.userAdmin = false;
      this.userTestScheduler = false;
    } else if (this.user === '3') {
      this.userTestScheduler = true;
      this.userAdmin = false;
      this.userEvaluator = false;  
    }
  }

  simpletest() {
      this.testtakerservice.test_taker(this.test).subscribe(
      (data) => {

       this.result = data.results;
        return this.result;
      },
      err => {
        console.error(err);
      }
    );
  }

  getTempRowData() {
    this.newAttribute = { candidatename: '',college_name:'',academic_year:'', questionsetname: '', pattern: '', date: '', time: '', paperlist: '', scheduler: ''};

    this.fieldArray.push(this.newAttribute);
  }
  College_Name() {
    this.fs.College_Name(this.college_set).subscribe(
      (data) => {

        this.college = data.results;


      },
      err => {
        console.error(err);
      }
    );

    // this.testtakerservice.test_taker(this.test).subscribe(
    //   (data) => {
    //
    //    this.result1 = data.results;
    //
    //

    //   }
    // );
  }


display_candid(){
  // this.searchhide=false;
  // this.dropdownhide=true;
  // this.display_cand=false;
  window.location.reload();
}

  display_candidates(){
   this.display_cand=true;
   this.dropdownhide=false;
   this.searchhide=true;
    this.local.collegeid=this.collegeid
     this.local.yearid=this.yearid


    this.columns = this.auth.getColumns();
    this.fs.display_candidate(this.local).subscribe(
      (data) => {



        this.college = data.results;
        // localStorage.setItem('section_button',JSON.stringify(this.section[this.id]))
        localStorage.setItem('Candidates',JSON.stringify(this.college));
        this.router.navigate(['view_candidates']);
        this.College_Name1=this.college[0].College_Name

        this.Year_Name=this.college[0].Year




      },
      err => {
        console.error(err);
      }
    );


  }

  delete_candidates(){
    // this.display_cand=true;
    // this.dropdownhide=false;
    // this.searchhide=true;
     this.local.collegeid=this.collegeid
      this.local.yearid=this.yearid


     this.columns = this.auth.getColumns();
     console.log("this.local",this.local);
     this.fs.delete_candidate(this.local).subscribe(
       (data) => {


         if(data.code==200){
           Swal.fire({
            title: 'Success',
            text: 'Deleted Candidates Successfully!',
            icon: 'success',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
              return;
            }
          })
         }
         else{
           Swal.fire({
            title: 'Alert',
            text: 'Candidates cant be deleted',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              // this.router.navigateByUrl('/test_scheduler');
            }
          })
         }
         // localStorage.setItem('section_button',JSON.stringify(this.section[this.id]))


       },
       err => {
         console.error(err);
       }
     );


   }


  Upload_click(){
    this.router.navigate(['/upload_candidate']);
  }

  selectChangeHandler1(event: any, i: any) {

    this.selectedindex = i;

    this.selectedcollegeset = event.target.value;

    this.collegeid=this.selectedcollegeset;
    console.log( this.selectedcollegeset);
    this.ys.academicyear(this.selectedcollegeset).subscribe(
             (data) => {

              this.Year = data.results;
              console.log(this.Year);
              this.fieldArray[i].academic_year = data.results;



             },
                   err => {
                     console.error(err);
                   }
             );
     }
     selectChangeHandler2(event: any, i: any) {

      this.selectedindex = i;

      this.selectedyearset = event.target.value;


      this.yearid=this.selectedyearset;
       }
  edit(row) {


    this.router.navigate(['/edit_testtaker', row.id]);
    // this.testtakerservice.edit_test_taker(row).subscribe(
    //   (data) => {
    //     this.router.navigate(['/edit', row.id]);
    //
    //
    //     sessionStorage.setItem('id', data.results[0].id);
    //     sessionStorage.setItem('firstName', data.results[0].first_name);
    //     sessionStorage.setItem('lastName', data.results[0].last_name);
    //     sessionStorage.setItem('Email', data.results[0].email);
    //
    //     sessionStorage.setItem('Phone', data.results[0].phone);
    //     sessionStorage.setItem('type', data.results[0].type);
    //
    //     if (data.code === 200) {
    //       this.router.navigateByUrl('/test_taker');
    //       }
    //   });
  }
  delete(user) {

    this.testtakerservice.delete_test_taker(user).subscribe(
      (data) => {
        console.log("data.code inside testtaker",data.code)
        if(data.code === 200){
        Swal.fire({
          title: 'Success',
          text: data.success,
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            
              window.location.reload();
              return;
          }
        })
      }else if (data.code === 400) {
        Swal.fire({
          title: 'Alert',
          text: data.failed,
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            // this.router.navigateByUrl('/test_scheduler');
          }
        })

      }

      });
  }

  OnAddTestTaker(form: NgForm) {

    this.router.navigateByUrl('/createTestTaker');
  }
  // designTest() {
  //   this.router.navigateByUrl('/designTest');
  // }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
}
